import React, { useEffect, useState } from 'react';
import ConfigContext from 'contexts/config/context';
import { getConfig } from 'requests/config';
import Loader from 'components/ui/loader';

const ConfigProvider = ({ children }) => {
  const [configLoading, setConfigLoading] = useState(true);
  const [config, setConfig] = useState({
    collections: {
      product_statuses: [],
    },
  });

  const fetchConfig = () => {
    getConfig()
      .then((response) => {
        setConfig(response.data.config);
        setConfigLoading(false);
      })
      .catch(() => {
        setConfigLoading(false);
      });
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  if (configLoading) {
    return <Loader />;
  }

  return (
    <ConfigContext.Provider
      value={{
        collections: config.collections,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;
